import { Pipe, PipeTransform } from '@angular/core';
import { ISearchFilter } from '../models/search-filter.model';

@Pipe({
  name: 'filterCategory'
})
export class FilterCategoryPipe implements PipeTransform {

  transform(items: ISearchFilter[], filterCategory: string): ISearchFilter[] {
    if (!items || !filterCategory || items.length == 0) {
      return items;
    }
    return items.filter(item => item.filterCategory === filterCategory);
  }

}